import { SpreadsheetComponent } from '@syncfusion/ej2-react-spreadsheet';
import { useEffect, useRef, useState } from 'react';
import { createLogger } from '../../../helpers/Logger';
const logger = createLogger({ prefix: '[RFP Viewer]' });

interface QuestionsSpreadsheetViewerProps {
  file?: File | null;
}

const QuestionsSpreadsheetViewer = ({
  file = null
}: QuestionsSpreadsheetViewerProps) => {
  const spreadsheetRef = useRef<SpreadsheetComponent | null>(null);
  const [openError, setOpenError] = useState<string>('');

  const openFile = (selectedFile: File) => {
    if (!spreadsheetRef.current) {
      return;
    }
    try {
      setOpenError('');
      spreadsheetRef.current.open({ file: selectedFile });
    } catch (error) {
      setOpenError(
        'There was an error opening this file. Please try another file.'
      );
      logger.error('error opening spreadsheet in viewer', error);
    }
  };

  useEffect(() => {
    if (!file) {
      return;
    }
    openFile(file);
  }, [file]);

  return (
    <div className="relative p-4 flex w-[100%] h-[100%] overflow-y-scroll border border-green-800 ">
      {openError ? (
        <p className="absolute z-10 m-3 rounded bg-red-100 px-3 py-2 text-xs text-red-700">
          {openError}
        </p>
      ) : null}
      <SpreadsheetComponent
        ref={spreadsheetRef}
        width={'100%'}
        height={'100%'}
        allowOpen={true}
        allowResizing={true}
        // openSettings={{}}
        openUrl="https://spreadsheet.korucompliance.com/api/spreadsheet/open"
        saveUrl="https://spreadsheet.korucompliance.com/api/spreadsheet/save"
        showFormulaBar={false}
        showRibbon={false}
        allowFiltering={false}
        allowEditing={false}
        allowWrap={true}
      />
    </div>
  );
};

export default QuestionsSpreadsheetViewer;
